/**
 * @desc 列表
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.warehouseOrganize.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/warehouseOrganize/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
